module.exports = __webpack_public_path__ + "static/media/StandingTall.99ea6391.mp3";